import styled from '@emotion/styled';

export const CardTitle = styled.p`
    font: ${(props) => props.theme.fonts.heading5};
    color: ${(props) => props.theme.palette.text.primary};
`;
